import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { dateFormat } from 'common/helpers/dateHelper';

import ClubShipDate from '../shipment/components/subscription/ClubShipDate';
import { isShipmentAdjustable } from '../shipment/components/subscription/helpers';

const SubscriptionShipment = (props) => {
  const { clubMembership } = props;

  const settings = useSelector((state) => state.setting);
  const clubSubscriptionShipment = useSelector(
    (state) =>
      state.clubSubscriptionShipment?.data?.[
        clubMembership.activeClubSubscriptionShipmentId
      ]
  );
  if (!clubSubscriptionShipment) {
    return (
      <>
        <br />
        Next Process Date:{' '}
        {dateFormat(clubMembership.subscription.nextProcessDate, settings)}
        <br />
        <Link
          to={`/profile/club-membership/${clubMembership.id}`}
          className="c7-button-alt-small"
        >
          Edit
        </Link>
      </>
    );
  }
  return (
    <div className="c7-account-tile__section__club-shipment">
      <br />
      <ClubShipDate
        clubSubscriptionShipment={clubSubscriptionShipment}
        settings={settings}
      />
      <br />
      {clubSubscriptionShipment.virtualCart
        ? renderItems(clubSubscriptionShipment.virtualCart.items)
        : renderItems(clubSubscriptionShipment.items)}
      {isShipmentAdjustable(clubSubscriptionShipment) && (
        <Link
          to={`/profile/club-membership/${clubMembership.id}/shipment`}
          className="c7-button-alt-small c7-button-alt-small--adjust"
        >
          Adjust
        </Link>
      )}
      {!isShipmentAdjustable(clubSubscriptionShipment) && (
        <Link
          to={`/profile/club-membership/${clubMembership.id}`}
          className="c7-button-alt-small"
        >
          Edit
        </Link>
      )}
    </div>
  );
};

const renderItems = (items) =>
  items.map((item) => (
    <Fragment key={item.id}>
      <span className="c7-account-tile__section__club-shipment__item">
        {item.quantity} of {item.productTitle}
      </span>
    </Fragment>
  ));

export default SubscriptionShipment;
